import React, { useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { AvatarRound, BtnV2, l } from '@manychat/manyui'

import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import {
  AiAlwaysOnAutomationsActions,
  AiAlwaysOnAutomationsSelectors,
} from 'apps/aiAutomation/store/core'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { getInstagramChannel } from 'common/core/selectors/channelSelectors'

import cm from './styles.module.css'

export const EmptyState = () => {
  const dispatch = useAppDispatch()

  const tovState = useAppSelector(AiAlwaysOnAutomationsSelectors.getTovState)

  const replies = useMemo(
    () => [
      l.translate('That means a lot! So glad it spoke to you 💛'),
      l.translate('Your feedback truly inspires us to keep creating!'),
    ],
    [],
  )

  const { avatar } = useAppSelector(getInstagramChannel)

  const initSetup = () => {
    if (!tovState) {
      AiAutomationAnalytics.logTovRateProcessStarted({
        is_first_generation: true,
      })

      dispatch(AiAlwaysOnAutomationsActions.startTovSetupFx())
    }

    dispatch(
      AiAutomationLayoutActions.viewOpened({
        view: SidebarViewType.TOV_SETUP,
      }),
    )
  }

  return (
    <div>
      <h4 className="m-b text-subheading">{l.translate('Set AI’s tone')}</h4>

      <div className={cm.preview}>
        <ul className={cm.replies}>
          {replies.map((reply, index) => (
            <li className={cm.reply} key={index}>
              <AvatarRound src={avatar} size="xsmall" />

              <p className="m-0">{reply}</p>
            </li>
          ))}
        </ul>

        <p>
          {l.translate(
            'AI picks up your tone from Instagram comments and drafts replies for you to review.',
          )}
        </p>

        <BtnV2 onClick={initSetup} className="m-t-md" variant="primary" fullWidth>
          {l.translate('Set AI’s tone')}
        </BtnV2>
      </div>
    </div>
  )
}
